var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55556 11.5554C2.41467 11.5554 3.11111 10.859 3.11111 9.99989C3.11111 9.14078 2.41467 8.44434 1.55556 8.44434C0.696446 8.44434 0 9.14078 0 9.99989C0 10.859 0.696446 11.5554 1.55556 11.5554Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5378 8.44434H7.68442C6.87686 8.44434 6.2222 9.09899 6.2222 9.90656V10.0932C6.2222 10.9008 6.87686 11.5554 7.68442 11.5554H26.5378C27.3453 11.5554 28 10.9008 28 10.0932V9.90656C28 9.09899 27.3453 8.44434 26.5378 8.44434Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5378 16.2222H1.46222C0.654659 16.2222 0 16.8768 0 17.6844V17.8711C0 18.6786 0.654659 19.3333 1.46222 19.3333H26.5378C27.3453 19.3333 28 18.6786 28 17.8711V17.6844C28 16.8768 27.3453 16.2222 26.5378 16.2222Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5378 0.666504H1.46222C0.654659 0.666504 0 1.32116 0 2.12873V2.31539C0 3.12296 0.654659 3.77762 1.46222 3.77762H26.5378C27.3453 3.77762 28 3.12296 28 2.31539V2.12873C28 1.32116 27.3453 0.666504 26.5378 0.666504Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.d1452217eed41266b172ad007483b83b.svg";
export { ForwardRef as ReactComponent };